/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/tendertransaction
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyOrderKey,
  ShopifyShopKey,
  ShopifyTenderTransactionKey,
  ShopifyTenderTransactionToOrderKey,
  ShopifyTenderTransactionToShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyTenderTransactionKey,
  "2022-01": {
    name: "Shopify Tender Transaction",
    fields: [
      {
        name: "Amount",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "amount" } },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "currency" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyTenderTransactionToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Payment Details",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "payment_details" } },
      },
      {
        name: "Payment Method",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "payment_method" } },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "processed_at" } },
      },
      {
        name: "Remote Reference",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "remote_reference" } },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "test" } },
      },
      // {
      //   name: "User",
      //   fieldType: FieldType.BelongsTo,
      //   key: ShopifyTenderTransactionToUserKey,
      //   contributorConfiguration:  { [ShopifyDominion.id]: { shopifyFieldKey: "user_id" } },
      //   configuration: {
      //     relatedModelKey: ShopifyUserKey,
      //   },
      // },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyTenderTransactionToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "tenderTransaction" },
  },
  "2025-04": {
    graphQLTypename: "TenderTransaction",
    fields: [
      {
        name: "Amount",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "amount",
            graphQLFieldKey: "shop_amount",
            availableInWebhook: ["tender_transactions/create"],
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "currency",
            graphQLFieldKey: "currency",
            availableInWebhook: ["tender_transactions/create"],
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["tender_transactions/create"],
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyTenderTransactionToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "order_id",
            graphQLFieldKey: "order",
            graphQLSelection: "id",
            availableInWebhook: ["tender_transactions/create"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Payment Details",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            availableInWebhook: ["tender_transactions/create"],
            shopifyFieldKey: "payment_details",
            graphQLFieldKey: "transactionDetails",
            graphQLSelection: `
            ... on TenderTransactionCreditCardDetails {
                creditCardCompany
                creditCardNumber
            }
          `,
          },
        },
      },
      {
        name: "Payment Method",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "payment_method",
            graphQLFieldKey: "paymentMethod",
            availableInWebhook: ["tender_transactions/create"],
          },
        },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "processed_at",
            graphQLFieldKey: "processedAt",
            availableInWebhook: ["tender_transactions/create"],
          },
        },
      },
      {
        name: "Remote Reference",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "remote_reference",
            graphQLFieldKey: "remoteReference",
            availableInWebhook: ["tender_transactions/create"],
          },
        },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "test", graphQLFieldKey: "test", availableInWebhook: ["tender_transactions/create"] },
        },
      },
      {
        name: "Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "amount_set",
            graphQLOnlyField: true,
            graphQLFieldKey: "amount",
            graphQLSelection: `
          amount
          currencyCode
          `,
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "tenderTransactions",
      filters: {},
    },
  },
};

export const ShopifyTenderTransaction = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
